export const getTranslationKey = (baseKey: string, value: number) => {
  const keySuffix = value > 1 ? 'plural' : 'singular';
  return `${baseKey}.${keySuffix}`;
};
